var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderSubTotalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.771 9.771H5.97933",
    stroke: "#0D0706",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.354 1.3125C3.354 1.08044 3.44619 0.857876 3.61029 0.693782C3.77438 0.529687 3.99694 0.4375 4.229 0.4375H7.14567C7.37773 0.4375 7.60029 0.529687 7.76439 0.693782C7.92848 0.857876 8.02067 1.08044 8.02067 1.3125V1.89583C8.02067 2.1279 7.92848 2.35046 7.76439 2.51455C7.60029 2.67865 7.37773 2.77083 7.14567 2.77083H4.229C3.99694 2.77083 3.77438 2.67865 3.61029 2.51455C3.44619 2.35046 3.354 2.1279 3.354 1.89583V1.3125Z",
    stroke: "#0D0706",
    strokeWidth: 0.875
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 8.6043C10.9375 10.2546 10.9375 11.0794 10.4247 11.5921C9.91258 12.1043 9.08717 12.1043 7.4375 12.1043H3.9375C2.28783 12.1043 1.46242 12.1043 0.95025 11.5921C0.4375 11.0788 0.4375 10.2546 0.4375 8.6043V6.8543M8.02083 1.60547C9.28958 1.61247 9.97675 1.66905 10.4247 2.11705C10.9375 2.6298 10.9375 3.45464 10.9375 5.1043V6.27097M3.35417 1.60547C2.08542 1.61247 1.39825 1.66905 0.95025 2.11705C0.50225 2.56505 0.445667 3.25222 0.438667 4.52097M2.77083 7.7293H3.35417M7.4375 7.7293H5.10417",
    stroke: "#0D0706",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderSubTotalIcon);
export default __webpack_public_path__ + "static/media/order-sub-total-icon.07f3fe57d21d53f344b8b66d9add4450.svg";
export { ForwardRef as ReactComponent };